import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation, AfterViewInit, OnDestroy } from '@angular/core';
import { state, style, transition, animate, trigger, AUTO_STYLE } from '@angular/animations';

import 'rxjs/add/operator/filter';
import { MenuService } from '../../shared/services/menu.service';
import { AuthService } from '../../core/services/auth/auth.service';
import { LocalStorageService } from '../../shared/services/loca-storage.service';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { AlertService } from '../../../../src/app/shared/services/alert.service';
import { IOption } from 'ng-select';
import { ValuesListService } from "../../core/services/admin/values-list.service";
@Component({
  selector: 'app-dashboard-layout',
  templateUrl: './dashboard-layout.component.html',
  styleUrls: ['./dashboard-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('mobileMenuTop', [
      state('no-block, void',
        style({
          overflow: 'hidden',
          height: '0px',
        })
      ),
      state('yes-block',
        style({
          height: AUTO_STYLE,
        })
      ),
      transition('no-block <=> yes-block', [
        animate('400ms ease-in-out')
      ])
    ])
  ]
})
export class DashboardLayoutComponent implements OnInit, AfterViewInit, OnDestroy {

  icons = [
    'assets/images/menu_lateral/config_sistema.svg',
    'assets/images/menu_lateral/cont_terceros.svg',
    'assets/images/menu_lateral/nacionales.svg',
    'assets/images/menu_lateral/equivalentes.svg',
    'assets/images/menu_lateral/nacionales.svg',
    'assets/images/menu_lateral/hv_active_index.svg',
    'assets/images/menu_lateral/pagos.svg',
    'assets/images/menu_lateral/pagos.svg',
  ];
  deviceType = 'desktop';
  verticalNavType = 'expanded';
  verticalEffect = 'shrink';
  chatToggle = 'out';
  chatInnerToggle = 'off';
  innerHeight: string;
  isScrolled = false;
  isCollapsedMobile = 'no-block';
  toggleOn = true;
  windowWidth: number;
  @ViewChild('searchFriends') search_friends: ElementRef;
  @ViewChild('toggleButton') toggle_button: ElementRef;
  @ViewChild('sideMenu') side_menu: ElementRef;

  config: any;
  user: any;
  userMenu: any[];
  openMenu = false;

  menuSlide: any[] = [];
  menuChildren: any[] = [];
  expanded = false;

  private usersub: any;
  public userMenusub: any[];
  public submenushow: boolean = false;
  public txtname: any;
  public txtnamecompany: any;
  public txt_auto_welcome: any;
  urlLogo: string;

  dataCompany: any;

  constructor(public menuItems: MenuService,
    private storageService: LocalStorageService
    , private router: Router
    , private authService: AuthService
    , public titleService: Title
    , private alertService: AlertService,
    private valuesList: ValuesListService,) {
      
    const scrollHeight = window.screen.height - 150;
    this.innerHeight = scrollHeight + 'px';
    this.windowWidth = window.innerWidth;
    this.setMenuAttributs(this.windowWidth);
    this.Auto_welcome();
    this.getProfile();
  }

  ngOnInit() {
    this.authService.getTokenUser();    
    this.initUserMenu();
  }

  ngOnDestroy() {
    this.storageService.remove('changeCompany')
  }

  ngAfterViewInit(): void {
    
  }

/*   action(item) {
    if (item.type === 'link') {
      if (item.main_state) {
        this.router.navigate([`/${item.main_state}/${item.state}`]);
      } else {
        this.router.navigate([`/${item.state}`]);
      }
      return;
    }
  } */
  action(item) {
    if (!item.active) {
      if (item.type === 'link') {
        if (item.disabled)
          {
            this.router.navigate([`/${item.state}`]);
            return;
          }
        if (item.state) {
         console.log("ESTADOPARAM",item.state);
         this.subMenu(item);
         this.submenushow = !this.submenushow;
         this.menuSlide[0].items.map( function(i){
          if(i.state !== item.state){
            i.active = !i.active;
          } else if (i.state === item.state) {
            i.active = false;
          }
         });
        } 
      }
    }
  }

  onClickedOutside(e: Event) {
    if (this.windowWidth < 768 && this.toggleOn && this.verticalNavType !== 'offcanvas') {
      this.toggleOn = true;
      this.verticalNavType = 'offcanvas';
    }
  }

  onResize(event) {
    this.innerHeight = event.target.innerHeight + 'px';
    /* menu responsive */
    this.windowWidth = event.target.innerWidth;
    let reSizeFlag = true;
    if (this.deviceType === 'tablet' && this.windowWidth >= 768 && this.windowWidth <= 1024) {
      reSizeFlag = false;
    } else if (this.deviceType === 'mobile' && this.windowWidth < 768) {
      reSizeFlag = false;
    }

    if (reSizeFlag) {
      this.setMenuAttributs(this.windowWidth);
    }
  }

  setMenuAttributs(windowWidth) {
    if (windowWidth >= 768 && windowWidth <= 1024) {
      this.deviceType = 'tablet';
      this.verticalNavType = 'offcanvas';
      this.verticalEffect = 'push';
    } else if (windowWidth < 768) {
      this.deviceType = 'mobile';
      this.verticalNavType = 'offcanvas';
      this.verticalEffect = 'overlay';
    } else {
      this.deviceType = 'desktop';
      this.verticalNavType = 'expanded';
      this.verticalEffect = 'shrink';
    }
  }

  toggleOpened() {
    if (this.windowWidth < 768) {
      this.toggleOn = this.verticalNavType === 'offcanvas' ? true : this.toggleOn;
      this.verticalNavType = this.verticalNavType === 'expanded' ? 'offcanvas' : 'expanded';
    } else {
      this.verticalNavType = this.verticalNavType === 'expanded' ? 'offcanvas' : 'expanded';
    }
  }
  onMobileMenu() {
    this.isCollapsedMobile = this.isCollapsedMobile === 'yes-block' ? 'no-block' : 'yes-block';
  }

  onScroll(event) {
    this.isScrolled = false;
  }

  onLogout() {
    let token = this.authService.getTokenUser();

    this.authService.logout(token, {
      success: (resp) => {
        if (resp.data.code === 0) {
          this.authService.removeToken();
        } else {
          this.alertService.openSwal({
            text: resp.data.msg,
            type: 'error'
          });
        }
      }, error: (err) => {
        console.log('error', err);
      }
    });
  }

  changePassword() {
    this.router.navigate(['/profile']);
  }
  subMenu( parent : any) {
     
      this.userMenusub = parent.children;
      console.log("SUBMENU",this.userMenusub);
  }

  actionSub(item: any) {

    if(item.ind_permission != undefined && !item.ind_permission ){ 
      this.alertService.openSwal(
        {
          text : 'Lo sentimos su contrato no posee permisos para esta acción.',
          type : 'warning'
        }
      );
      return;
    }
    let makeRoute = `/${item.state}`;

    switch (item.type) {

      case 'link':
        if (item.main_state)
          makeRoute = `/${item.main_state}${makeRoute}`

        this.router.navigate([makeRoute]);
        break;

      case 'sub':
        if (item.children && item.children.length > 0){
          /* Se permite la navegacacion del primer item con permiso */
          let child_permissions = item.children.filter( child => { return child.ind_permission })

          makeRoute = `${makeRoute}/${child_permissions[0].state}`
        }

        if (item.main_state)
          makeRoute = `/${item.main_state}${makeRoute}`

        this.router.navigate([makeRoute]);
        break;

      default:
        break;
    }
  }

  Auto_welcome(){
    let dataH = [
      [0, 12, "¡Buenos dias!, "],
      [12, 18, "¡Buenas tardes!, "],
      [18, 24, "¡Buenas Noches!, "]
  ],
      hr = new Date().getHours();
  
  for(var i=0; i<dataH.length;i++){
      if(hr >= dataH[i][0] && hr <= dataH[i][1]){
         this.txt_auto_welcome = dataH[i][2];
         break;
      }
  }
  }

  dirHome() {
    this.menuSlide[0].items.map( function(i){
      i.active = false;
    });
    this.submenushow = false;
    if (this.windowWidth < 768) {
      this.toggleOn = this.verticalNavType === 'offcanvas' ? true : this.toggleOn;
      this.verticalNavType = this.verticalNavType === 'expanded' ? 'offcanvas' : 'expanded';
    }
  }

  infoCompany() {
    return new Promise((resolve, reject) => {
      this.storageService.get('changeCompany').then(
        (data: any) => {
          // console.log("data", data)
          resolve(data);
        }).catch((e) => {
          reject('Error storageService' + e);
        });
    });
  }


  async getProfile() {

    await new Promise(f => setTimeout(f, 1000));
    this.valuesList.getLookupsValues({ lookup_type: 'PERFIL_AUDITORIA' },
      {
        success: resp => {
          if (resp.status === 0) {
            
            const lisTemp = resp.data.map((item) => {

              return {
                id_pefil: item.lookup_code,
                label: item.description,
              };
            });
            
            const lisTemp2 = this.user.perfiles.map((item) => {

              return {
                id_pefil: item.id_pefil.toString(),
                label: item.perfil,
              };
            });
            console.log("PROFILE",lisTemp)
            console.log("PERFILES", lisTemp2)
        
            const extractValue = ({ 'id_pefil': id_pefil }) => id_pefil;
            const duplicateValues = lisTemp
            .map(extractValue)
            .filter(x => lisTemp2
              .map(extractValue)
              .includes(x)
            );
            console.log("MATCHesS",JSON.stringify(duplicateValues));
            if (duplicateValues.length != 0){
              console.log("si tiene perfil solo lectura")
              localStorage.setItem("UserOnlyRead", "true");
            }
       
          }
        },
        error: err => {
          console.log(err);
        }
      });
  }



  initUserMenu(){
    let cantItems: number = 9;
    let tmp: number = 0;
    let arrtmp: any[] = [];

    this.authService.getSession().then((user: any) => {      
      this.user = user;
      this.txtname = this.user.firstName+" "+this.user.lastName;
      this.txtnamecompany = this.user.razon_social;
      this.urlLogo = this.user.url_logo;
      const menuItems = this.menuItems.getMenu(this.user);
      const items: any[] = [];
      const profile: { id_pefil: number, perfil: string }[] = this.user.perfiles;

      menuItems.forEach((item) => {
        item.main.forEach((element) => {
          this.infoCompany().then(
            (resp: any) => {
              if (resp !== null) {
                if (!resp.modulos_contrato.some((item) => item.id_modulo == element.id_modulo)) element.disabled = true;
              } else {
                if (!element.ind_contract) element.disabled = true;
                // if (!this.user.modulos_contrato.some((item) => item.id_modulo == element.id_modulo)) element.disabled = true;
              }
            }
          )
          if (element.ind_permission) items.push(element);
          // let intersection: any[] = profile.filter(x => element.profile.includes(x.id_pefil))
          // if (intersection.length > 0) {
          //   items.push(element);
          // }
        });
      });


      items.forEach((element, index) => {
        if (tmp < cantItems) {
          arrtmp.push(element);
          tmp = tmp + 1;
        }

        if ((index == items.length - 1) || (tmp >= cantItems)) {
          this.menuSlide.push({ items: arrtmp });
          tmp = 0;
          arrtmp = [];
        }
      });
      console.log(this.menuSlide[0].items);
      this.menuSlide[0].items.forEach(async (element) => {
        element.active = false;
      });  

      this.menuItems.build_menu();
    }).catch((e) => {
      console.log('ContentLayoutComponent->ngAfterViewInit', e);
    });
    
  }

}


// WEBPACK FOOTER //
// ./src/app/layouts/dashboard-layout/dashboard-layout.component.ts